const config = {
    app_url : process.env.VUE_APP_URL,
    server_url: process.env.VUE_APP_SERVER_URL,
    mode : process.env.NODE_ENV,
    local : process.env.VUE_APP_LOCAL,
    app_title: process.env.VUE_APP_TITLE,
    client_token: process.env.VUE_APP_CLIENT_TOKEN,
    google_tag_manager_key : process.env.VUE_APP_GOOGLE_TAG_MANAGER_KEY,
    itemsPerPage : 20,
    fetchCount : 20
};

export default config;